import { LightLogo } from './components'

function LogoFreteBras() {
  function handleLogoClick() {
    window.location.href = '/'
  }

  return (
    <LightLogo
      width={160}
      height={63}
      primaryColor="#00AEEF"
      secondaryColor="#000000"
      onClick={handleLogoClick}
      alt="Logo FreteBras"
    />
  )
}

export default LogoFreteBras
